module.exports = __webpack_public_path__ + "media/images/home_bg-410bbaf3.png";